// extracted by mini-css-extract-plugin
export default {"imgHolder":"FestivalTile_imgHolder__Q5YXZ","img":"FestivalTile_img__7YZ-T"};